import { api } from "../../Config/ApiConfig";

export const forgotPassword = async (email, captchaToken) => {
  const { data } = await api.post('/auth/forgot-password', { email, 'turnstile_token': captchaToken }, {
    headers: captchaToken ? { 'turnstile_token': captchaToken } : undefined
  });
  return data;
};
